import { cn } from '@folio/index';

interface GarantiePlusLogoProps {
  className?: string;
}

export function GarantiePlusLogo({ className }: GarantiePlusLogoProps) {
  return (
    <img
      src="/Logo Garantie Plus wo text.png"
      alt="Garantie Plus Logo"
      className={cn('h-10', className)}
    />
  );
}
